import React from 'react';
import PropTypes from 'prop-types';
import { forgeClassHelper } from '../utils/classes';

const classes = forgeClassHelper('table');

const nextDirection = (direction) => {
  switch (direction) {
    case 'asc':
      return 'desc';
    case 'desc':
      return 'asc';
    default:
      return 'asc';
  }
};

// says what clicking button *will* do, so opposite of current sort state
const getDirectionLabel = (direction) => {
  switch (direction) {
    case 'asc':
      return 'descending';
    case 'desc':
      return 'ascending';
    default:
      return 'descending';
  }
};

const SortableTableHeader = ({ text, direction, onSort }) => (
  <button
    {...classes({
      element: 'header',
      modifiers: 'sortable',
    })}
    onClick={() => {
      onSort(nextDirection(direction));
    }}
    aria-label={`Sort by ${text} in ${getDirectionLabel(direction)} order`}
    type="button"
  >
    <span {...classes('header-text')}>{text}</span>
    <span
      {...classes({
        element: 'sort-control',
        states: direction,
      })}
    />
  </button>
);

SortableTableHeader.propTypes = {
  text: PropTypes.string,
  direction: PropTypes.oneOf(['asc', 'desc']),
  onSort: PropTypes.func,
};

export default SortableTableHeader;
